import { useEffect } from 'react';
import { Container, Modal, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useMapContext } from '@/contexts/MapContext';
import { CatchmentForm, CatchmentFormValues } from '../catchmentform/CatchmentForm';
import styles from './catchmentmodal.module.css';

type CatchmentModalProps = {
  setComplete: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CatchmentModal = ({ setComplete }: CatchmentModalProps) => {
  const { isCatchmentLoading, isCatchmentSuccess, setCatchment } = useMapContext();
  const [opened, { close }] = useDisclosure(true);

  useEffect(() => {
    if (isCatchmentSuccess) {
      setComplete(true);
      close();
    }
  }, [isCatchmentSuccess]);

  const handleCatchmentFormSubmitted = (values: CatchmentFormValues) => {
    setCatchment(values);
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withinPortal={false}
      classNames={{
        body: styles.catchmentModal,
      }}
      styles={{
        overlay: { position: 'absolute' },
      }}
    >
      <Container style={{ gap: '12px' }}>
        <Text size="lg" ta="center" fw={500}>
          Welcome
        </Text>
        <Text size="sm" ta="center">
          Please select a river basin district or specific catchments to begin. You can always
          change this later in the Layers & Filters tab.
        </Text>
      </Container>
      <CatchmentForm
        onSubmit={handleCatchmentFormSubmitted}
        isLoading={isCatchmentLoading}
        isInitialSelection
      />
    </Modal>
  );
};
